export default [
  {
    name: 'basicstatistics',
    path: 'basicstatistics',
    component: () =>
      import(
        /* webpackChunkName: "basicstatistics" */ './NewCustServiceAnalysis.vue'
      )
  },
  {
    name: 'GoogleAnalysis',
    path: '/google_analysis',
    component: () =>
      import(/* webpackChunkName: "GoogleAnalysis" */ './GoogleAnalysis.vue')
  },
  {
    name: 'report_income',
    path: '/report/income',
    component: () =>
      import(/* webpackChunkName: "report_income" */ './IncomeExpenditrue.vue')
  },
  {
    name: 'report_user',
    path: '/report/user',
    component: () => import(/* webpackChunkName: "report_user" */ './User.vue')
  },
  {
    name: 'report_live',
    path: '/report/live',
    component: () => import(/* webpackChunkName: "report_live" */ './Live.vue')
  },
  {
    name: 'points_analysis',
    path: '/points_analysis',
    component: () =>
      import(
        /* webpackChunkName: "points_analysis" */ './PointsAnalysis/PointsAnalysis.vue'
      )
  },
  {
    name: 'report_offline_promotion',
    path: '/report/offline_promotion',
    component: () =>
      import(
        /* webpackChunkName: "report_offline_promotion" */ './OfflinePromotion.vue'
      )
  },
  {
    name: 'report_merchants_analyzing',
    path: '/report/merchants_analyzing',
    component: () =>
      import(
        /* webpackChunkName: "report_merchants_analyzing" */ './MerchantsAnalyzing.vue'
      )
  },
  {
    name: 'report_transaction_analyzing',
    path: '/report/transaction_analyzing',
    component: () =>
      import(
        /* webpackChunkName: "report_transaction_analyzing" */ './TransactionAnalyzing.vue'
      )
  },
  {
    name: 'report_cash_counter_analyzing',
    path: '/report/cash_counter_analyzing',
    component: () =>
      import(
        /* webpackChunkName: "report_cash_counter_analyzing" */ './CashCounterAnalyzing.vue'
      )
  },
  {
    name: 'report_loan_account_analysis',
    path: '/report/loan_account_analysis',
    component: () =>
      import(
        /* webpackChunkName: "report_loan_account_analysis" */ './LoanAccountAnalysis.vue'
      )
  },
  {
    name: 'report_saving_account_analysis',
    path: '/report/saving_account_analysis',
    component: () =>
      import(
        /* webpackChunkName: "report_saving_account_analysis" */ './SavingAccountAnalysis.vue'
      )
  },
  {
    name: 'active_user_analysis',
    path: '/report/active_user_analysis',
    component: () =>
      import(
        /* webpackChunkName: "report_active_user_analysis" */ './ActiveUserAnalyzing.vue'
      )
  },
  {
    name: 'report_coupon_event',
    path: '/report/coupon_event',
    component: () =>
      import(
        /* webpackChunkName: "report_coupon_event" */ './CouponEventAnalysis.vue'
      )
  },
  {
    name: 'report_invite_firends_event',
    path: '/report/invite_firends_event',
    component: () =>
      import(
        /* webpackChunkName: "report_invite_firends_event" */ './InviteFirendsEventAnalysis.vue'
      )
  },
  {
    name: 'report_redpack_event',
    path: '/report/redpack_event',
    component: () =>
      import(
        /* webpackChunkName: "report_redpack_event" */ './RedpackEventAnalysis.vue'
      )
  },
  {
    name: 'bank_transfer_report',
    path: '/report/bank_transfer',
    component: () =>
      import(
        /* webpackChunkName: "bank_transfer_report" */ './BankTransferReport.vue'
      )
  },
  {
    name: 'third_party_payment_report',
    path: '/report/third_party_payment',
    component: () =>
      import(
        /* webpackChunkName: "third_party_payment_report" */ './ThirdPartyPayment.vue'
      )
  },
  {
    name: 'dps_transaction_analysis_report',
    path: '/report/dps_transaction_analysis',
    component: () =>
      import(
        /* webpackChunkName: "dps_transaction_analysis_report" */ './DpsTransactionAnalysis.vue'
      )
  }
]
